export function getShipmentPercentageText(value: number, totalShipments: number): string {
  if (!value || !totalShipments) {
    return '0% of your shipments'
  }

  const percentage = Number(((value / totalShipments) * 100).toFixed(1))

  return `${percentage}% of your shipments`
}
